import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { scrollToElement } from '../../../utils/scroll-to';

import styles from './index.module.scss';

const PageAlert = ({
  onClose = () => {},
  children,
  className = '',
  showCloseButton = true,
  ...domProps
}) => {
  useEffect(() => {
    // Scroll to the message.
    const scrollElementParams = {
      elementId: 'page-alert',
      offset: 80,
    };
    scrollToElement(scrollElementParams);
  }, []);

  return (
    <div className={`${styles['page-alert-container']} ${className}`}>
      <div id="page-alert" {...domProps} className={styles['page-alert']}>
        {children}
        {showCloseButton && (
          <span className={styles['close-button']} onClick={onClose} onKeyPress={onClose} />
        )}
      </div>
    </div>
  );
};

PageAlert.propTypes = {
  onClose: PropTypes.func,
  className: PropTypes.string,
  showCloseButton: PropTypes.bool,
};

export default PageAlert;
